import React from 'react';
import Icon from './icon';

function NavIcon(props) {
	console.log('Nav Icon', props)
  return (
		<div>
			{
				!props.navigator ?
					<button
						onClick={props.handleClick}
					>
						<Icon {...props}>
							<path d="m0 28h43v3h-43zm0-14h43v3h-43zm0-14h43v3h-43z"/>
						</Icon>
					</button>

				:
					<button
						onClick={props.handleClick}
					>
						<Icon {...props}>
							<path d="m14 1.4-1.4-1.4-5.6 5.6-5.6-5.6-1.4 1.4 5.6 5.6-5.6 5.6 1.4 1.4 5.6-5.6 5.6 5.6 1.4-1.4-5.6-5.6z" />
						</Icon>
					</button>
			}
		</div>
  )
}

export default NavIcon;



// WEBPACK FOOTER //
// ./src/components/icons/nav-icon.js